import { Icon } from "@iconify/react";
import { ErrorMessage, Field, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { Texterror } from "../../../constants/Texterror";
import { useDispatch, useSelector } from "react-redux";
import {
  citylistiso as citylist,
  servicelist,
  refTypesList,
} from "../../../redux/actions/dbactions/refactions";
import { Header } from "../../Header";
import { useLocation } from "react-router-dom";
import PaymentSuccessModal from "../../../Modals/PaymentSuccessModal";
import PaymentFailedModal from "../../../Modals/PaymentFailedModal";

export const ExploreForm = ({ handleSubmit = () => {} }) => {
  let orderPatient = {};
  const { search } = useLocation();
  const [isCountrySelected, setIsCountrySelected] = useState(false);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailedModal, setShowFailedModal] = useState(false);
  const { refsdata } = useSelector((state) => state.refstypes);
  const { citis, isLoading: citiesLoading } = useSelector(
    (state) => state.cities
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(refTypesList());
  }, [dispatch]);

  // const validationSchema = Yup.object().shape({
  //   svc_type_id: Yup.string().required("Service type is required"),
  //   iso_city_id: Yup.string().required("City is required"),
  //   iso_cntry_id: Yup.string().required("Country is required"),
  // });

  const countryname = refsdata.usr?.iso_cntry_explore || [];
  const citiesName = citis.usr?.iso_city || [];

  const handleCountryChange = (event, setFieldValue) => {
    const selectedCountryId = event.target.value;
    dispatch(citylist(selectedCountryId));

    if (selectedCountryId) {
      setIsCountrySelected(true);
    } else {
      setIsCountrySelected(false);
    }

    setFieldValue("iso_cntry_id", selectedCountryId);
  };

  const handleCityChange = (event, setFieldValue) => {
    const selectedCityId = event.target.value;

    setFieldValue("iso_city_id", selectedCityId);
    dispatch(servicelist(selectedCityId)).then((response) => {
      setServiceTypes(response.usr.FacSvcTyp);
    });
  };

  const handleServiceChange = (event, setFieldValue) => {
    const newServiceId = event.target.value;
    setFieldValue("svc_type_id", newServiceId);
    const service = serviceTypes.find(
      (s) => s.svc_typ_id === Number(newServiceId)
    );
    if (service) {
      setFieldValue("svc_typ_desc", service.svc_typ_desc);
    }
  };

  useEffect(() => {
    if (search?.includes("success")) {
      setShowSuccessModal(true);
    }
    if (search?.includes("failed")) {
      setShowFailedModal(true);
    }
  }, [search]);

  orderPatient = JSON.parse(localStorage.getItem("newPatient"));

  return (
    <div className="profile">
      <Header
        pageTitle="Explore"
        icon={
          <Icon icon="material-symbols:explore-outline" className="w-4 h-4" />
        }
      />
      <div className="card_white_box w-100">
        <h5 className="globale-title sm:px-14">
          <span>
            {orderPatient?.svcuser_profile_id
              ? `Find Trusted Providers for ${orderPatient.user_first_name}`
              : "Find Trusted Providers"}
          </span>
        </h5>
        <Formik
          initialValues={{
            svc_type_id: "",
            iso_city_id: "",
            iso_cntry_id: "",
            svc_provider_name: "",
          }}
          // validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({ touched, errors, values, handleSubmit, setFieldValue }) => (
            <Form onSubmit={handleSubmit}>
              <Row className="mb-4 sm:px-14">
                <Col lg={12}>
                  <div className="mb-3 position-relative">
                    <Form.Select
                      className="form-control pe-5 truncate"
                      name="iso_cntry_id"
                      aria-label="Default select example"
                      onChange={(e) => handleCountryChange(e, setFieldValue)}
                    >
                      <option>Which Country do you need Service?</option>
                      {countryname.map((item, index) => (
                        <option key={index} value={item.iso_cntry_id}>
                          {item.iso_cntry_name}
                        </option>
                      ))}
                    </Form.Select>
                    <ErrorMessage name="iso_cntry_id" component={Texterror} />
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="mb-3 position-relative">
                    <div className="position-relative">
                      <Form.Select
                        className="form-control pe-5 truncate"
                        name="iso_city_id"
                        aria-label="Default select example"
                        onChange={(e) => handleCityChange(e, setFieldValue)}
                        disabled={!isCountrySelected}
                      >
                        <option>What City?</option>
                        {isCountrySelected &&
                          citiesName.map((city) => (
                            <option
                              key={city.iso_city_id}
                              value={city.iso_city_id}
                            >
                              {city.iso_city_name}
                            </option>
                          ))}
                      </Form.Select>
                      {citiesLoading && (
                        <div className="loader-container">
                          <Spinner
                            animation="border"
                            size="sm"
                            variant="primary"
                          />
                        </div>
                      )}
                    </div>
                    <ErrorMessage name="iso_city_id" component={Texterror} />
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="mb-3 position-relative">
                    <div className="mb-3">
                      <Form.Select
                        className="form-control pe-5 truncate"
                        name="svc_type_id"
                        aria-label="Default select example"
                        onChange={(e) => handleServiceChange(e, setFieldValue)}
                        value={values.svc_type_id}
                      >
                        <option>What type of service do you need?</option>
                        {serviceTypes.map((item) => (
                          <option key={item.svc_typ_id} value={item.svc_typ_id}>
                            {item.svc_typ_desc}
                          </option>
                        ))}
                      </Form.Select>
                      <ErrorMessage name="svc_type_id" component={Texterror} />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="sm:px-14">
                <Col>
                  <h5>
                    <span>
                      <b>OR</b>
                    </span>
                  </h5>
                </Col>
              </Row>

              <Row className="sm:px-14">
                <Col>
                  <div className="mb-3">
                    <Form.Label>
                      Type your prefered provider name here (i.e Clinic, Lab
                      ,Pharmacy or hospital) by name
                    </Form.Label>
                    <Field
                      className={`form-control ${
                        touched.svc_provider_name && errors.svc_provider_name
                          ? "is-invalid"
                          : ""
                      }`}
                      name="svc_provider_name"
                      type="input"
                      placeholder="for example: Restore"
                      value={values.svc_provider_name}
                    />
                    <ErrorMessage
                      name="svc_provider_name"
                      component={Texterror}
                    />
                  </div>
                </Col>
              </Row>

              <Row className="sm:px-14">
                <Col>
                  <div className="mini_edit">
                    <button
                      className="sign_btn"
                      style={{ visibility: "hidden" }}
                    >
                      Cancel
                    </button>
                    <button
                      className="sign_btn"
                      /* disabled={user_has_profile_yn === "N"}*/
                    >
                      Find My Care Options
                    </button>
                  </div>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </div>
      <PaymentSuccessModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
      />
      <PaymentFailedModal
        show={showFailedModal}
        setShowFailedModal={setShowFailedModal}
        onHide={() => setShowFailedModal(false)}
      />
    </div>
  );
};
